
import React from 'react';
import { Box, Typography } from '@mui/material';
import {useIsMobile} from "@/hooks/use-mobile.tsx";

interface PageWrapperProps {
  header?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
}

const PageWrapper = ({ header = <></>, title, children }: PageWrapperProps) => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
      <Box sx={{px: 2, py: 2, minHeight: 68,  boxSizing: 'border-box', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Typography variant="body1" fontWeight="bold" fontSize={20}>{title}</Typography>
          <Box sx={{flex: 1, justifyContent: 'flex-end', display: 'flex'}}>
            {header}
          </Box>
        </Box>
      </Box>
      <Box sx={{
        boxSizing: 'border-box',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
        pb: isMobile ? 0 : 2,
        px: isMobile ? 0 : 2,
        width: '100%'
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default PageWrapper;
